import React from 'react';
import { formatDateTime, statusColorClass } from '../lib/openPlatformFormatters';

const WebhookDeliveryDrawer = ({ open, onClose, items = [] }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[120] flex justify-end bg-black/55">
      <div className="h-full w-full max-w-2xl overflow-y-auto border-l border-slate-700 bg-slate-950 p-4">
        <div className="mb-3 flex items-center justify-between">
          <h3 className="text-sm font-semibold text-slate-100">Delivery Logs</h3>
          <button type="button" onClick={onClose} className="text-xs text-slate-400 hover:text-slate-200">Tutup</button>
        </div>
        <div className="space-y-3">
          {items.map((item) => (
            <div key={item.deliveryId} className="rounded border border-slate-800 bg-slate-900/70 p-3">
              <div className="flex flex-wrap items-center gap-2">
                <span className={`inline-flex rounded border px-2 py-0.5 text-[11px] font-semibold ${statusColorClass(item.status)}`}>
                  {item.status}
                </span>
                <span className="text-[11px] text-slate-400">{item.eventType}</span>
                <span className="text-[11px] text-slate-500">Retry {item.retryCount}</span>
              </div>
              <div className="mt-2 grid gap-1 text-[11px] text-slate-300">
                <p>Response Code: {item.responseCode || '-'}</p>
                <p>Created: {formatDateTime(item.createdAt)}</p>
                <p>Delivered: {formatDateTime(item.deliveredAt)}</p>
                <p className="text-slate-400">Response: {item.responseBody || '-'}</p>
              </div>
              <details className="mt-2 rounded border border-slate-800 bg-slate-950 p-2">
                <summary className="cursor-pointer text-[11px] text-cyan-300">Payload Preview</summary>
                <pre className="mt-2 max-h-48 overflow-auto whitespace-pre-wrap text-[10px] text-slate-300">{JSON.stringify(item.payload, null, 2)}</pre>
              </details>
            </div>
          ))}
          {items.length === 0 ? <p className="rounded border border-slate-800 bg-slate-900/70 p-4 text-xs text-slate-400">Belum ada delivery log.</p> : null}
        </div>
      </div>
    </div>
  );
};

export default WebhookDeliveryDrawer;
